import React from "react";
import { PopperProps, Popper as MuiPopper } from "@mui/material";

// For all tooltips and popovers we should use this component,
// which correctly handles position relative to element, and prevents overlaps and cut off UI
// When we deprecate mui we can switch either to our own implementation or use react-popper lib
const Popper = (props: PopperProps): JSX.Element => {
  return <MuiPopper style={{ zIndex: "1000" }} {...props} />;
};

export type Placement = PopperProps["placement"];

export default Popper;
